import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, catchError, map, of, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from './api-response.model';
import { CreateGuestReviewBody, GuestReviewView } from '../../models/review.model';
import { CustomerAuthService } from '../auth/customer-auth.service';

@Injectable({ providedIn: 'root' })
export class ReviewApiService {
  private readonly http = inject(HttpClient);
  private readonly customerAuth = inject(CustomerAuthService);
  private readonly base = environment.apiBaseUrl;

  list(featuredOnly = false): Observable<GuestReviewView[]> {
    const url = featuredOnly ? `${this.base}/reviews?featured=true` : `${this.base}/reviews`;
    return this.http.get<ApiResponse<GuestReviewView[]>>(url).pipe(
      map((r) => r.data ?? []),
      catchError(() => of([])),
    );
  }

  create(body: CreateGuestReviewBody): Observable<GuestReviewView> {
    const token = this.customerAuth.getToken();
    const headers = token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : undefined;
    return this.http.post<ApiResponse<GuestReviewView>>(`${this.base}/reviews`, body, { headers }).pipe(
      map((r) => {
        if (!r.data) {
          throw new Error('Review was not saved');
        }
        return r.data;
      }),
      catchError((err: unknown) => throwError(() => err)),
    );
  }
}
